<sd-icon class="tab__icon" [type]="icon"></sd-icon>
<div *ngIf="badgeCount > 0" class="tab__icon__badge">
  {{ badgeCount }}
</div>
<span class="tab__label">
  {{ label }}
</span>
